'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ckeditorConfig = require('./ckeditor-config');

var _ckeditorConfig2 = _interopRequireDefault(_ckeditorConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var REF_NAME = 'ckEditorTextbox';

var CkEditorTextbox = function (_React$Component) {
    _inherits(CkEditorTextbox, _React$Component);

    function CkEditorTextbox() {
        _classCallCheck(this, CkEditorTextbox);

        return _possibleConstructorReturn(this, (CkEditorTextbox.__proto__ || Object.getPrototypeOf(CkEditorTextbox)).apply(this, arguments));
    }

    _createClass(CkEditorTextbox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                onBlur = _props.onBlur,
                ckEditor = _props.ckEditor,
                initialContent = _props.initialContent,
                configuration = _props.configuration,
                onShowDialog = _props.onShowDialog,
                onHideDialog = _props.onHideDialog,
                additionalOptions = _props.additionalOptions;

            var conf = _ckeditorConfig2.default.types[configuration];
            if (!(0, _isEmpty2.default)(conf)) {
                conf = Object.assign({}, conf, additionalOptions);
            }
            this.ckEditorInstance = ckEditor.appendTo(this[REF_NAME], conf, initialContent);
            this.ckEditorInstance.on('change', function () {
                return _this2.update();
            });
            if (onBlur) {
                this.ckEditorInstance.on('blur', onBlur);
            }
            if (onShowDialog) {
                this.ckEditorInstance.on('dialogShow', function () {
                    return onShowDialog();
                });
            }
            if (onHideDialog) {
                this.ckEditorInstance.on('dialogHide', function () {
                    return onHideDialog();
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.ckEditorInstance.destroy();
        }
    }, {
        key: 'update',
        value: function update() {
            return this.props.onUpdate(this.ckEditorInstance.getData());
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement('div', { className: 'cc-ckeditor-textbox-comp',
                ref: function ref(elem) {
                    return _this3[REF_NAME] = elem;
                } });
        }
    }]);

    return CkEditorTextbox;
}(_react2.default.Component);

CkEditorTextbox.propTypes = {
    additionalOptions: _propTypes2.default.object,
    configuration: _propTypes2.default.oneOf(Object.keys(_ckeditorConfig2.default.types)),
    ckEditor: _propTypes2.default.object.isRequired,
    initialContent: _propTypes2.default.node,
    onBlur: _propTypes2.default.func,
    onUpdate: _propTypes2.default.func.isRequired,
    onShowDialog: _propTypes2.default.func,
    onHideDialog: _propTypes2.default.func
};
CkEditorTextbox.defaultProps = {
    configuration: 'DEFAULT',
    initialContent: ''
};
CkEditorTextbox.config = _ckeditorConfig2.default;
exports.default = CkEditorTextbox;
//# sourceMappingURL=index.js.map